import * as recipientActions from '../actions/recipients';
import { sortRecipientsByNewest } from '../../utils/recipientHelpers';

const defaultState = {
  recipients: null,
  highlightedRecipientId: null,
};

// eslint-disable-next-line default-param-last
const recipients = (state = defaultState, action) => {
  switch (action.type) {
    case recipientActions.GET_RECIPIENTS: {
      const { getRecipientsError, ...newState } = state;
      return {
        ...newState,
        gettingRecipients: true,
      };
    }
    case recipientActions.GET_RECIPIENTS_SUCCESS:
      return {
        ...state,
        recipients: sortRecipientsByNewest(action.payload || []),
        gettingRecipients: false,
      };
    case recipientActions.GET_RECIPIENTS_ERROR:
      return {
        ...state,
        getRecipientsError: action.payload,
        gettingRecipients: false,
      };
    case recipientActions.GET_RECIPIENT: {
      const { getRecipientError, ...newState } = state;
      return {
        ...newState,
        gettingRecipient: true,
      };
    }
    case recipientActions.GET_RECIPIENT_SUCCESS:
      return {
        ...state,
        recipient: action.payload,
        gettingRecipient: false,
      };
    case recipientActions.GET_RECIPIENT_ERROR:
      return {
        ...state,
        getRecipientError: action.payload,
        gettingRecipient: false,
      };
    case recipientActions.ADD_RECIPIENT: {
      const { addRecipientError, ...newState } = state;
      return {
        ...newState,
        creatingRecipient: true,
      };
    }
    case recipientActions.ADD_RECIPIENT_SUCCESS:
      return {
        ...state,
        creatingRecipient: false,
        highlightedRecipientId: action.payload?.recipientId ?? action.payload ?? null,
      };
    case recipientActions.ADD_RECIPIENT_ERROR:
      return {
        ...state,
        addRecipientError: action.payload,
        creatingRecipient: false,
      };
    case recipientActions.UPDATE_RECIPIENT: {
      const { updateRecipientError, ...newState } = state;
      return {
        ...newState,
        updatingRecipient: true,
      };
    }
    case recipientActions.UPDATE_RECIPIENT_SUCCESS:
      return {
        ...state,
        recipients: (state.recipients || []).map((recipient) => (recipient.id === action.payload.id ? action.payload : recipient)),
        recipient: action.payload,
        updatingRecipient: false,
      };
    case recipientActions.UPDATE_RECIPIENT_ERROR:
      return {
        ...state,
        updateRecipientError: action.payload,
        updatingRecipient: false,
      };
    case recipientActions.DELETE_RECIPIENT: {
      const { deleteRecipientError, ...newState } = state;
      return {
        ...newState,
        deletingRecipient: true,
      };
    }
    case recipientActions.DELETE_RECIPIENT_SUCCESS:
      return {
        ...state,
        recipients: (state.recipients || []).filter((recipient) => recipient.id !== action.payload),
        recipient: null,
        deletingRecipient: false,
      };
    case recipientActions.DELETE_RECIPIENT_ERROR:
      return {
        ...state,
        deleteRecipientError: action.payload,
        deletingRecipient: false,
      };
    case recipientActions.CLEAR_RECIPIENTS: {
      const { recipients, recipient, ...newState } = state;
      return newState;
    }
    case recipientActions.CLEAR_RECIPIENT: {
      const { recipient, ...newState } = state;
      return newState;
    }
    case recipientActions.CLEAR_GET_RECIPIENT_ERROR: {
      const { getRecipientError, ...newState } = state;
      return newState;
    }
    case recipientActions.CLEAR_ADD_RECIPIENT_ERROR: {
      const { addRecipientError, ...newState } = state;
      return newState;
    }
    case recipientActions.PARSE_RECIPIENT_DOCUMENT: {
      const { parseDocumentError, parsedDocumentData, ...rest } = state;
      return {
        ...rest,
        parsingDocument: true,
      };
    }
    case recipientActions.PARSE_RECIPIENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        parsingDocument: false,
        parseDocumentError: undefined,
        parsedDocumentData: action.payload,
      };
    case recipientActions.PARSE_RECIPIENT_DOCUMENT_ERROR:
      return {
        ...state,
        parsingDocument: false,
        parseDocumentError: action.payload,
        parsedDocumentData: undefined,
      };
    case recipientActions.CLEAR_PARSE_RECIPIENT_DOCUMENT: {
      const { parsingDocument, parseDocumentError, parsedDocumentData, ...rest } = state;
      return rest;
    }
    case recipientActions.CLEAR_HIGHLIGHTED_RECIPIENT:
      return {
        ...state,
        highlightedRecipientId: null,
      };
    default:
      return state;
  }
};

export default recipients;
